import Contact from './Contact.js'
export default Contact;
